'use strict';

var processInclude = require('./util');
require('base/components/spinner');

$(document).ready(function () {
  processInclude(require('./cart/cart'));
});
